export default __webpack_public_path__ + "static/media/art-museum-guild.052963c8.jpg";